import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table'
import { YYYYMMDDtoDate } from 'src/functions/format'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'src/hooks/redux'
import { RootState } from 'src/store'

type Props = {
  remarks: Remark[]
}
const Remarks = ({remarks}:Props) => {
  const {t} = useTranslation()

  const colleagues:ForwardUser[] = useAppSelector((state:RootState)=>state.colleagues)

  function usernameToName(name:string) {
    let n = name
    const user = Array.isArray(colleagues) ? colleagues.find(u=>u.username.toLowerCase() === name.toLowerCase()) : undefined
    if(user){
        n = `${user.firstname} ${user.name}`
    }
    return n
  }


  return (
    <div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t('Gebruiker')}</TableHead>
            <TableHead>{t('Datum')}</TableHead>
            <TableHead>{t('Opmerking')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {remarks.map((remark, index)=>(
          <TableRow key={index}>
            <TableCell>{usernameToName(remark.useradded)}</TableCell>
            <TableCell>{YYYYMMDDtoDate(remark.dateadded) ? format(YYYYMMDDtoDate(remark.dateadded), 'dd/MM/yyyy') : ''}</TableCell>
            <TableCell>{remark.remark}</TableCell>
          </TableRow>
        ))}
        </TableBody>
      </Table>
    </div>
  )
}

export default Remarks